import {NewInvitationType} from 'app/user/types';

import {teamListSource, userListSource} from '../../demo_fixtures';
import {createFakeUser} from '../../demo_fixtures/users';
import {EventEmitter} from '../../EventEmmiter';
import {useData, waitAndReturn} from '../../utils';

export const USER_RTK_TAG = 'user';
export const INVITATION_RTK_TAG = 'invitation';

export const useUsers = () => {
  const {isFetching, data} = useData(
    userListSource,
    'usersUpdate',
    eventEmitter
  );

  return {
    isFetching,
    data,
    refetch: () => {
      eventEmitter.emit('usersUpdate', userListSource);
    },
  };
};

const createUser = ({name, email}) => {
  return {
    unwrap: () => {
      return waitAndReturn(() => {
        const newUser = createFakeUser(name, email);
        userListSource.results.push(newUser);
        userListSource.count = userListSource.results.length;
        eventEmitter.emit('usersUpdate', userListSource);
        return newUser;
      });
    },
  };
};
export const useCreateUser = () => [createUser];

export const useLazyUsersQuery = () => ({});

const inviteUser = ({invitations}: {invitations: Array<NewInvitationType>}) => {
  return {
    unwrap: () => {
      return waitAndReturn(() => {
        const users = userListSource.results;
        users.map((user) => {
          const invitation = invitations.find(
            (inv) => inv.to_user_id === user.url
          );

          if (invitation != null) {
            const team = teamListSource.results.find(
              (team) => team.id === invitation.object_id
            );

            if (team != null) {
              user.teams.push({
                html_url: team.html_url,
                id: team.id,
                name: team.name,
                url: team.url,
              });

              user.team_memberships.push({
                team: team.url,
                url: team.url,
                is_manager: invitation.permission === 'edit',
                access:
                  invitation.permission === 'edit' ? 'manager' : 'teammate',
              });
            }
          }
        });

        userListSource.results = users;
        eventEmitter.emit('usersUpdate', userListSource);
        return Promise.resolve(true);
      });
    },
  };
};
export const useInviteUser = () => [inviteUser];

export const eventEmitter = new EventEmitter();

export const convertLocationParamsToFetchParams = () => ({});

export const useUserPermissions = () => ({});
